import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import "./style.scss";
import FormHelperText from "components/Form/components/FormHelperText";
import Toggle from "react-toggle";
import useLanguageProvider from "components/LanguageProvider/hooks/useLanguageProvider";
import FormSubtext from "../FormSubtext";
const Checkbox = ({ id, classes, error, label, name, register, setValue, ...inputProps }) => {
    const { translate: t } = useLanguageProvider();
    useEffect(() => {
        if (inputProps.defaultValue) {
            setValue(name, inputProps.defaultValue);
        }
    }, [inputProps.defaultValue, name, setValue]);
    const onChange = (data) => {
        var _a, _b;
        setValue(name, (_b = (_a = data === null || data === void 0 ? void 0 : data.target) === null || _a === void 0 ? void 0 : _a.checked) !== null && _b !== void 0 ? _b : false, { shouldValidate: true });
    };
    return (_jsxs("div", { className: "form__checkbox-toggle", children: [inputProps.subtext && _jsx(FormSubtext, { text: inputProps.subtext }), _jsxs("div", { className: "input__checkbox-toggle", children: [_jsx(Toggle, { ...(inputProps.disabled ? { disabled: true } : {}), ...(inputProps.defaultValue ? { defaultChecked: true } : {}), ...register(name), onChange: onChange, name: name, className: `input-checkbox ${classes !== null && classes !== void 0 ? classes : ""}`, id: id !== null && id !== void 0 ? id : name, "aria-label": typeof label === "string" ? label : name }), _jsx("label", { htmlFor: id !== null && id !== void 0 ? id : name, children: typeof label === "function" ? label({ t }) : t(label) })] }), error && _jsx(FormHelperText, { message: error.message })] }));
};
export default Checkbox;
